import { env } from '@sib/config';
import { tracking } from '@sib/tracking';
import { BadgeLocation, MEDIA_SM_QUERY } from '@spendbrain/config/constants';
import { DeviceType, getDeviceType } from '@spendbrain/utils/device-detection';
import { useMediaQuery } from './use-media-query';

interface UseAppStoreBadgesOptions {
  location: BadgeLocation;
  showDeviceSpecific?: boolean;
}

export const useAppStoreBadges = ({
  location,
  showDeviceSpecific = true,
}: UseAppStoreBadgesOptions) => {
  const deviceType = getDeviceType();
  const isMobile = useMediaQuery(MEDIA_SM_QUERY);

  const handleAppStoreClick = () =>
    tracking.track('App Store Badge Clicked', {
      platform: DeviceType.IOS,
      location,
    });

  const handleGooglePlayClick = () =>
    tracking.track('Google Play Store Badge Clicked', {
      platform: DeviceType.ANDROID,
      location,
    });

  const isDesktop = !isMobile || deviceType === DeviceType.DESKTOP;
  const showAppStore =
    !showDeviceSpecific || isDesktop || deviceType === DeviceType.IOS;
  const showGooglePlay =
    !showDeviceSpecific || isDesktop || deviceType === DeviceType.ANDROID;

  return {
    ...(showAppStore && { appStoreAppUrl: env.appStoreAppUrl }),
    ...(showGooglePlay && { googlePlayAppUrl: env.googlePlayAppUrl }),
    onAppStoreClick: handleAppStoreClick,
    onGooglePlayClick: handleGooglePlayClick,
  };
};
